import React from "react";
import Image from "./Image";


const Loading = () => {
  return (
    <div
      className="flex-center"
      style={{
        height: "100vh",
      }}
    >
      <Image src="/loader.gif" alt="" className="loading-gif" />
    </div>
  );
};

export default Loading;




























